export enum CorrectionStatus {
    CORRECTED = "corrected",
    TO_CORRECT = "to-correct",
    WITHOUT_WORK = "without-work",
    NO_CORRECTED = "non-corrected",
}

export default CorrectionStatus;
